import {DG_axiosNormal} from "../../axios/normal";

const BASE_URL_REFRESH_TOKEN = `/login-rest/v2.0/refreshtoken`;
const BASE_URL_LOG_OUT = `/login-rest/v2.0/logout`;

export const refreshToken = () => {
    return DG_axiosNormal.post(
        BASE_URL_REFRESH_TOKEN,
        {},
        {
            withCredentials: true
        }
    );
};

export const logout = () => {
    return DG_axiosNormal.post(
        BASE_URL_LOG_OUT,
        {},
        {
            withCredentials: true
        }
    );
}